// TODO: create a ImageWidgetCreator that accepts the cloundinary name

import React from 'react';
import axios from 'axios';

const {
  REACT_APP_CLOUDINAY_CLOUD_NAME,
  REACT_APP_CLOUDINAY_UPLOAD_PRESET,
} = process.env;

const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${REACT_APP_CLOUDINAY_CLOUD_NAME}/image/upload`;
// const DELETE_URL = `https://api.cloudinary.com/v1_1/${REACT_APP_CLOUDINAY_CLOUD_NAME}/image/destroy`;

function Image({ id, isUploading, isDeleting }) {
  if (isUploading) {
    return (<div>
      UPLOADING...
    </div>);
  } else if (isDeleting) {
    return (<div>
      REMOVING...
    </div>);
  }
  if (!id) {
    return null;
  }
  const src = `http://res.cloudinary.com/${REACT_APP_CLOUDINAY_CLOUD_NAME}/image/upload/${id}`;
  return <img style={{ margin: '20px 0', height: '200px', width: '200px', objectFit: 'contain' }} src={src} alt="uploaded" />;
}

function encodeFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
  });
}

class ImageWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUploading: false,
      isDeleting: false,
    };
  }
  render() {
    const { options: { canDelete }, value, options } = this.props;
    const handleChange = async (e) => {
      const file = await encodeFile(e.target.files[0]);

      try {
        this.setState({ isUploading: true });
        const response = await axios.post(
          UPLOAD_URL,
          {
            file,
            upload_preset: REACT_APP_CLOUDINAY_UPLOAD_PRESET,
          },
        );
        this.props.onChange(response.data.public_id);
        this.setState({ isUploading: false });
      } catch (error) {
        // TODO: handle error
        console.log('error uploading file', error);
        this.setState({ isUploading: false });
      }
    };

    const handleRemove = async () => {
      try {
        this.setState({ isDeleting: true });
        // TODO: commented out deleting from cloudinary, evaluate if this is needed
        // await axios.post(
        //   DELETE_URL,
        //   {
        //     public_id: value,
        //   },
        // );
        this.props.onChange('');
        this.setState({ isDeleting: false });
      } catch (error) {
        // TODO: handle error
        console.log('error deleting file', error);
        this.setState({ isDeleting: false });
      }
    };

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItem: 'flex-start', justifyContent: 'flex-start' }} >
        <div className="image-widget__file-inputs">
          <input
            type="file"
            ref={(input) => { this.inputElement = input; }}
            onChange={handleChange}
            className="image-widget__file"
          />
          <div className="image-widget__fakefile">
            <input
              type="button"
              value="Choose File"
              onClick={() => this.inputElement.click()}
            />
            <span className="image-widget__label">No file chosen</span>
          </div>
        </div>
        <Image id={value} isUploading={this.state.isUploading} isDeleting={this.state.isDeleting} />
        {(options && canDelete && !this.state.isDeleting && value) && (
          <button style={{ width: '150px' }} onClick={handleRemove}>Remove</button>
        )}
      </div>
    );
  }
}

export default ImageWidget;



// WEBPACK FOOTER //
// ./src/widgets/ImageWidget.js